import React from "react";
// Import images
import aboutImg from "../../assets/img/about/01.jpg";
import deliveryImg from "../../assets/img/about/delivery-service.jpg"; // Add your delivery image
// Import Material-UI icons
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import TrafficIcon from "@mui/icons-material/Traffic";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PsychologyIcon from "@mui/icons-material/Psychology";
import LinkIcon from "@mui/icons-material/Link";
import GroupsIcon from "@mui/icons-material/Groups";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";

const AboutArea = () => {
  return (
    <div>
      <style jsx>{`
        .site-title {
          color: #000000 !important;
        }
        .site-title span {
          color: #098535 !important;
        }
        .benefits-list {
          list-style: none;
          padding-left: 0;
          margin: 0;
        }
        .benefits-list li {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;
          padding: 0;
        }
        .benefit-icon {
          margin-right: 15px;
          color: #098535;
          font-size: 24px;
          min-width: 24px;
          margin-top: 2px;
        }
        .benefit-content {
          flex: 1;
        }
        .extended-section {
          background: #f8f9fa;
          padding: 80px 0;
          margin-top: 60px;
        }
        .service-highlight {
          background: white;
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
          height: 100%;
        }

        /* Button hover styles */
        .green-btn {
          background: #098535 !important;
          border: none !important;
          padding: 12px 30px;
          border-radius: 25px;
          display: inline-flex;
          align-items: center;
          color: white !important;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .green-btn:hover {
          background: #fede33 !important; /* Yellow on hover */
          color: #000000 !important; /* Black text on hover */
        }

        .green-btn:hover i {
          color: #000000 !important; /* Black icon on hover */
        }

        .yellow-btn {
          background: #fede33 !important; /* Yellow background */
          border: none !important;
          padding: 12px 30px;
          border-radius: 25px;
          display: inline-flex;
          align-items: center;
          color: #000000 !important; /* Black text */
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .yellow-btn:hover {
          background: #098535 !important; /* Green on hover */
          color: white !important; /* White text on hover */
        }

        .yellow-btn:hover i,
        .yellow-btn:hover svg {
          color: white !important; /* White icon on hover */
        }

        .outline-btn {
          background: transparent !important;
          border: 2px solid #098535 !important;
          color: #098535 !important;
          padding: 12px 30px;
          border-radius: 25px;
          display: inline-flex;
          align-items: center;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .outline-btn:hover {
          background: #fede33 !important; /* Yellow on hover */
          border-color: #fede33 !important;
          color: #000000 !important; /* Black text on hover */
        }

        .outline-btn:hover svg {
          color: #000000 !important; /* Black icon on hover */
        }
      `}</style>

      <div className="about-area py-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                <div className="about-img">
                  <img src={aboutImg} alt="CabandGo transportation services" />
                </div>
                <div className="about-experience">
                  <div className="about-experience-icon">
                    <DirectionsCarIcon
                      sx={{
                        fontSize: 60,
                        color: "#fede33",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "10px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                      }}
                    />
                  </div>
                  <b>
                    Reducing Urban <br /> Stress Daily
                  </b>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-right wow fadeInRight"
                data-wow-delay=".25s"
                style={{ textAlign: "left" }}
              >
                <div
                  className="site-heading mb-3"
                  style={{ textAlign: "left" }}
                >
                  <span
                    className="site-title-tagline"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <DriveEtaIcon
                      sx={{
                        fontSize: 20,
                        marginRight: "8px",
                        color: "#fede33",
                      }}
                    />
                    Our Story
                  </span>
                  <h2
                    className="site-title"
                    style={{
                      color: "#000000",
                      textAlign: "left",
                    }}
                  >
                    Connecting Communities, <span>Reducing Stress</span> One
                    Ride at a Time
                  </h2>
                </div>
                <p
                  className="about-text"
                  style={{
                    textAlign: "left",
                    color: "#000000",
                    lineHeight: "1.8",
                  }}
                >
                  It all started with a simple observation: the daily struggle
                  of commuting was taking a toll on people's well-being. Whether
                  in bustling urban centers or remote rural areas, the stress of
                  unreliable transportation was affecting productivity, health,
                  and quality of life.
                </p>
                <p
                  className="about-text"
                  style={{
                    textAlign: "left",
                    color: "#000000",
                    lineHeight: "1.8",
                  }}
                >
                  We founded CabandGo with a mission to transform this reality.
                  Our vision is to create a seamless transportation ecosystem
                  that not only gets you from point A to B but does so in a way
                  that reduces anxiety, saves time, and brings peace of mind to
                  your daily journey.
                </p>
                <div
                  className="about-list-wrapper"
                  style={{ textAlign: "left" }}
                >
                  <ul className="benefits-list">
                    <li>
                      <TrafficIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Urban Relief:</strong> Beating traffic with
                        smart routing and multiple transport options
                      </div>
                    </li>
                    <li>
                      <LocationCityIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Rural Access:</strong> Bridging transportation
                        gaps in underserved communities
                      </div>
                    </li>
                    <li>
                      <AccessTimeIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Time Savior:</strong> Giving you back precious
                        hours for what truly matters
                      </div>
                    </li>
                    <li>
                      <PsychologyIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Stress-Free Experience:</strong> From booking to
                        arrival, we handle the worries
                      </div>
                    </li>
                    <li>
                      <LinkIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Seamless Integration:</strong> One platform for
                        all your mobility needs
                      </div>
                    </li>
                    <li>
                      <GroupsIcon className="benefit-icon" />
                      <div className="benefit-content">
                        <strong>Community Focus:</strong> Empowering local
                        drivers and strengthening neighborhoods
                      </div>
                    </li>
                  </ul>
                </div>
                <div style={{ textAlign: "left" }}>
                  <a href="/about" className="green-btn mt-4">
                    Join Our Movement
                    <i
                      className="fas fa-arrow-right"
                      style={{ marginLeft: "8px" }}
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Extended Section - Rides and Beyond */}
          <div className="extended-section">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div
                  className="service-highlight wow fadeInLeft"
                  data-wow-delay=".25s"
                >
                  <div
                    className="site-heading mb-4"
                    style={{ textAlign: "left" }}
                  >
                    <span
                      className="site-title-tagline"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <DeliveryDiningIcon
                        sx={{
                          fontSize: 20,
                          marginRight: "8px",
                          color: "#fede33",
                        }}
                      />
                      Rides and Beyond
                    </span>
                    <h2
                      className="site-title"
                      style={{
                        color: "#000000",
                        textAlign: "left",
                        fontSize: "2.2rem",
                      }}
                    >
                      Connecting Cities to <span>Remote Villages</span>
                    </h2>
                  </div>

                  <div style={{ textAlign: "left" }}>
                    <h3
                      style={{
                        color: "#098535",
                        marginBottom: "15px",
                        fontSize: "1.4rem",
                      }}
                    >
                      Comprehensive Mobility Ecosystem:
                    </h3>
                    <p
                      className="about-text"
                      style={{
                        textAlign: "left",
                        color: "#000000",
                        lineHeight: "1.8",
                        fontSize: "1.1rem",
                      }}
                    >
                      Beyond connecting passengers from their starting point to
                      destination, we're revolutionizing how communities access
                      essential services. We enable quick delivery of local
                      cuisine from your favorite neighborhood eateries,
                      facilitate timely transport for medical appointments and
                      prescriptions, provide innovative cargo solutions for
                      small businesses, and offer corporate mobility packages
                      that streamline employee transportation. Simultaneously,
                      we're creating sustainable earning opportunities for
                      drivers and delivery partners across all our service
                      platforms.
                    </p>
                  </div>

                  <div style={{ textAlign: "left", marginTop: "25px" }}>
                    <h3
                      style={{
                        color: "#098535",
                        marginBottom: "15px",
                        fontSize: "1.4rem",
                      }}
                    >
                      Bridging the Urban-Rural Divide:
                    </h3>
                    <p
                      className="about-text"
                      style={{
                        textAlign: "left",
                        color: "#000000",
                        lineHeight: "1.8",
                        fontSize: "1.1rem",
                      }}
                    >
                      We're connecting bustling city centers to the remotest
                      villages by providing reliable parcel and goods delivery
                      services. Our network ensures that essential packages,
                      important documents, and vital supplies reach even the
                      most isolated communities, breaking down geographical
                      barriers and creating economic opportunities for all.
                    </p>
                  </div>

                  <div style={{ textAlign: "left", marginTop: "30px" }}>
                    <a
                      href="/services"
                      className="green-btn"
                      style={{ marginRight: "15px" }}
                    >
                      Explore Services
                      <i
                        className="fas fa-arrow-right"
                        style={{ marginLeft: "8px" }}
                      ></i>
                    </a>
                    <a href="/delivery" className="outline-btn">
                      Delivery Info
                      <ConnectWithoutContactIcon
                        sx={{ fontSize: 16, marginLeft: "8px" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="about-img wow fadeInRight"
                  data-wow-delay=".25s"
                  style={{ textAlign: "center" }}
                >
                  <img
                    src={deliveryImg}
                    alt="CabandGo delivery services connecting urban and rural areas"
                    style={{
                      borderRadius: "15px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutArea;
